import { collection, doc, getDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { ThemeTag } from "../types";
import { ThemeTagDB } from "./ThemeTagDB";

export const getThemeTagDetails = async (
  themeTagId: string,
): Promise<ThemeTag> => {
  const collectionRef = collection(db, "themeTags");

  const themeTagSnapshot = await getDoc(doc(collectionRef, themeTagId));

  return new ThemeTagDB(themeTagSnapshot).toThemeTag();
};
